mutation UpdateAttendeeDetails(
  $attendeeId: ID!
  $changes: AttendeeDetailsChangesInput!
  $notify: Boolean
) {
  updateAttendeeDetails(
    input: { attendeeId: $attendeeId, changes: $changes, notify: $notify }
  ) {
    attendee {
      id
    }
  }
}
